<template>
  <div class="small text-muted">
    {{ t('needHelp.poradit') }}
    <br class="d-md-none">
    {{ t('needHelp.ozveteSe') }} <br class="d-none d-md-inline" >
    {{ t('needHelp.pres') }}
    <a v-if="isMicrosite" class="text-secondary" href="https://www.jake-james.cz/kontakt-kancelar-v-praze" target="_blank" rel="noopener">
    {{ t('needHelp.formular') }} </a>
    <a v-else class="text-secondary" href="/#jakeContactForm" @click.prevent="scrollToContactForm">
    {{ t('needHelp.formular') }} </a> {{ t('needHelp.nebo') }} <a class="text-secondary" href="tel:+420226224724">{{ t('needHelp.zavolejte') }}</a>.
  </div>
</template>

<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'

export default {
  name: "NeedHelp",
  data() {
    return {
      store
    }
  },
  setup() {
    const {t,locale} = useI18n({useScope: 'global'})
    const select = ref(0)
    const lang = locale;
    return {t, select, lang}
  },
  computed: {
    isMicrosite() {
      const microsites = ['sidlofirmy-brno.cz', 'sidlo-praha3.cz', 'sidlo-praha10.cz', 'sidlonapraze1.cz', 'sidlofirmy-praha.cz'];
      const host = document.referrer ? new URL(document.referrer).host : window.location.host;
      return microsites.some(site => host.includes(site));
    }
  },
  methods: {
    scrollToContactForm() {
      const el = document.getElementById('jakeContactForm');
      if (el) {
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.scrollY - 110,
          behavior: 'smooth'
        });
      }
    }
  }
}
</script>

<style scoped>

</style>